import { CommonModule, NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Modal } from 'bootstrap';
import { CappyLoader } from '../../cappy-loader/cappy-loader';

export type ModalContent = {
	title: string;
	bodyStrings: string[];
	bodyHtml?: string;
	injectedComponent?: any;
	buttons: { text: string, className: string, close: boolean, callback?: () => void }[];
	injectedInputs?: { [key: string]: any };
};


@Component({
	selector: 'app-ng-modal',
	imports: [CommonModule, CappyLoader],
	templateUrl: './modal.html',
	styleUrl: './modal.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NG_Modal implements AfterViewInit {
	@ViewChild('BS_MODAL') demoModalEl!: ElementRef<HTMLDivElement>;
	
	private modal!: Modal;
	public content: ModalContent = {
		title: '',
		bodyStrings: [],
		buttons: [
		]
	}

	constructor( protected _cd: ChangeDetectorRef) { 

	 }

	ngAfterViewInit() {
		this.modal = Modal.getOrCreateInstance(this.demoModalEl.nativeElement);
		this._cd.detectChanges();
	}

	setContent(obj: ModalContent) {
		this.content = obj;
		this._cd.detectChanges();

	}

	open() { this.modal.show(); }
	close() { this.modal.hide(); }

}
